// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Rename “container” → “radio-container” to avoid Tailwind’s .container */
.radio-container {
  display: block;
  position: relative;
  padding-left: 33px;
  cursor: pointer;
  font-size: 14px;
  color: #868686;
  -webkit-user-select: none;
          user-select: none;
}

/* hide default radio input */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* the custom circle */
.radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 17px;
  width: 17px;
  border: 1.5px solid red;
  border-radius: 50%;
  transition: background-color .2s;
}

/* dot, hidden by default */
.radio-checkmark::after {
  content: "";
  position: absolute;
  display: none;
  top: 2px;
  left: 2px;
  width: 10.6px;
  height: 11px;
  border-radius: 50%;
  background: red;
}

/* show dot when checked */
.radio-container input:checked ~ .radio-checkmark::after {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/customRadioBtn.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB","sourcesContent":["/* Rename “container” → “radio-container” to avoid Tailwind’s .container */\n.radio-container {\n  display: block;\n  position: relative;\n  padding-left: 33px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #868686;\n  user-select: none;\n}\n\n/* hide default radio input */\n.radio-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* the custom circle */\n.radio-checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 17px;\n  width: 17px;\n  border: 1.5px solid red;\n  border-radius: 50%;\n  transition: background-color .2s;\n}\n\n/* dot, hidden by default */\n.radio-checkmark::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  top: 2px;\n  left: 2px;\n  width: 10.6px;\n  height: 11px;\n  border-radius: 50%;\n  background: red;\n}\n\n/* show dot when checked */\n.radio-container input:checked ~ .radio-checkmark::after {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
